export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: any; output: any; }
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

/** List of AllowedStationsResult records */
export type AllowedStationsResponse = {
  __typename?: 'AllowedStationsResponse';
  /** List of AllowedStationsResult records */
  results: Array<AllowedStationsResult>;
  /** A welcome message for Growers */
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

export type AllowedStationsResult = {
  __typename?: 'AllowedStationsResult';
  brand?: Maybe<Scalars['String']['output']>;
  isOnHold: Scalars['Boolean']['output'];
  recordNumber: Scalars['String']['output'];
  roles: Array<StationAuthRole>;
  tradingName?: Maybe<Scalars['String']['output']>;
};

export type BaleDetail = {
  __typename?: 'BaleDetail';
  baleNumber: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  lineNumber?: Maybe<Scalars['String']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  netKGs?: Maybe<Scalars['Decimal']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  sale?: Maybe<Scalars['String']['output']>;
  saleOutcome?: Maybe<Scalars['String']['output']>;
};

export enum Breed {
  All = 'ALL',
  Merino = 'MERINO',
  MidMicron = 'MID_MICRON',
  QuarterBred = 'QUARTER_BRED',
  Unclassified = 'UNCLASSIFIED',
  Xbd = 'XBD'
}

export type ContractedLot = {
  __typename?: 'ContractedLot';
  /** nzwplot.lh_tbales */
  bales?: Maybe<Scalars['Decimal']['output']>;
  /** nzwplot.lh_text3 */
  lineNumber?: Maybe<Scalars['String']['output']>;
  /** nzwpcor.ct_mic */
  micron?: Maybe<Scalars['Decimal']['output']>;
  /** nzwplot.lh_rnetkg */
  netKg?: Maybe<Scalars['Decimal']['output']>;
  /** nzwplot.lh_tbales */
  paymentDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Calculated */
  priceClean?: Maybe<Scalars['Decimal']['output']>;
  /** nzwplot.lh_clp_code */
  redaType?: Maybe<Scalars['String']['output']>;
  /** nzwplot.lh_refno */
  reference: Scalars['String']['output'];
  /** Calculated */
  result?: Maybe<ContractedLotResult>;
};

export enum ContractedLotResult {
  Accepted = 'ACCEPTED',
  ToBeApproved = 'TO_BE_APPROVED',
  YetToDeliver = 'YET_TO_DELIVER'
}

/**
 * A combination of values taken straight from LoomCreditorHistory and LoomStation,
 * plus some transformed fields:
 *  - NetProceedsGSTInclusive is GST inclusive version of NetProceedsExGST,
 *  - AccountSalesDate is a date taken from BrokingAccountSalesDate or PrivateAccountSalesDate depending which one is not empty,
 *  - SaleAndSeason is combination of SaleIdentity and SaleSeason
 * See CreditorHistoryRules for implementation of field transformations.
 */
export type CreditorHistoryDetail = {
  __typename?: 'CreditorHistoryDetail';
  /** Calculated by the handler */
  accountSalesDate?: Maybe<Scalars['LocalDate']['output']>;
  /** nzwpcrh.cr_tgrpr */
  grossProceedsExGST?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated by the handler */
  netProceedsGSTInclusive?: Maybe<Scalars['Decimal']['output']>;
  /** nzwpcrh.cr_prpdate */
  paymentDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Calculated by the handler */
  saleAndSeason?: Maybe<Scalars['String']['output']>;
  /** nzwpporg.po_brand */
  stationBrand?: Maybe<Scalars['String']['output']>;
  /** nzwpporg.po_code */
  stationRecordNumber: Scalars['String']['output'];
  /** nzwpcrh.cr_tbales */
  totalBalesInPayment?: Maybe<Scalars['Decimal']['output']>;
  /** nzwpcrh.cr_tnetkg */
  totalNetKgInPayment?: Maybe<Scalars['Decimal']['output']>;
};

/** Deletes a Speci */
export type DeleteSpeciRequestInput = {
  /** The Id of the Speci to delete */
  speciId: Scalars['UUID']['input'];
};

export type DocumentModel = {
  __typename?: 'DocumentModel';
  description?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  relativeUrl: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type GetDownloadLinkResponse = {
  __typename?: 'GetDownloadLinkResponse';
  documentLink?: Maybe<Scalars['String']['output']>;
  exceptionMessage?: Maybe<Scalars['String']['output']>;
  fileWasNotFoundError: Scalars['Boolean']['output'];
};

/** A request to get a single offer */
export type GetOfferRequestInput = {
  offerId: Scalars['UUID']['input'];
};

export type GetOfferResponse = {
  __typename?: 'GetOfferResponse';
  offer: OfferDto;
};

/** Requests a get speci by speci guid */
export type GetSpeciRequestInput = {
  /** The guid of the speci */
  speciId: Scalars['UUID']['input'];
};

/** A response containing a single speci object */
export type GetSpeciResponse = {
  __typename?: 'GetSpeciResponse';
  /** Speci data transfer object */
  speci: SpeciDto;
};

/** Requests a get details for stations */
export type GetStationDetailsForSpeciRequestInput = {
  /** The request time. */
  requestTime?: InputMaybe<Scalars['LocalDate']['input']>;
  /** The station record number. */
  stationRecordNumber: Scalars['String']['input'];
};

/** Station details for Speci */
export type GetStationDetailsForSpeciResponse = {
  __typename?: 'GetStationDetailsForSpeciResponse';
  /** The brand of the station (Wool Brand on bales) */
  brand?: Maybe<Scalars['String']['output']>;
  /** The current season contracts for the station */
  currentSeasonContracts: Array<SpeciContractDetail>;
  /** If the station is RWS */
  isRws: Scalars['Boolean']['output'];
  /** RWS status of the station */
  rwsStatus?: Maybe<Scalars['String']['output']>;
  /** The trading name of the station */
  tradingName?: Maybe<Scalars['String']['output']>;
  /** ZQ status of the station */
  zqStatus?: Maybe<Scalars['String']['output']>;
  /** ZQRX status of the station */
  zqrxStatus?: Maybe<Scalars['String']['output']>;
};

export type GrowerListOffersRequestInput = {
  currentPage: Scalars['Int']['input'];
  offerStatuses?: InputMaybe<Array<OfferStatus>>;
  orderBy: ListOffersOrderByOptions;
  orderByAscending: Scalars['Boolean']['input'];
  pageSize: Scalars['Int']['input'];
  stationRecordNumber: Scalars['String']['input'];
};

export type GrowerServiceMutation = {
  __typename?: 'GrowerServiceMutation';
  deleteSpeci: MutationResponse;
  documentLink: GetDownloadLinkResponse;
  setSpeci: MutationResponse;
  submitOffer: MutationResponse;
  submitSpeci: MutationResponse;
};


export type GrowerServiceMutationDeleteSpeciArgs = {
  request: DeleteSpeciRequestInput;
};


export type GrowerServiceMutationDocumentLinkArgs = {
  relativeUrl: Scalars['String']['input'];
};


export type GrowerServiceMutationSetSpeciArgs = {
  request: SetSpeciRequestInput;
};


export type GrowerServiceMutationSubmitOfferArgs = {
  request: SubmitOfferRequestInput;
};


export type GrowerServiceMutationSubmitSpeciArgs = {
  request: SubmitSpeciRequestInput;
};

export type GrowerServiceQuery = {
  __typename?: 'GrowerServiceQuery';
  allDocuments: Array<DocumentModel>;
  allowedStations?: Maybe<AllowedStationsResponse>;
  listBaleDetails: ListBaleDetailsResponse;
  listCreditorHistory?: Maybe<ListCreditorHistoryResponse>;
  listLotDetails?: Maybe<ListLotDetailsResponse>;
  listOffers: ListOffersResponse;
  listReceivalHistory: ListReceivalHistoryResponse;
  listSoldWoolSummary?: Maybe<ListSoldWoolSummaryResponse>;
  listSpecis?: Maybe<ListSpeciResponse>;
  listWoolContracts?: Maybe<ListWoolContractsResponse>;
  offer?: Maybe<GetOfferResponse>;
  speci?: Maybe<GetSpeciResponse>;
  stationDetailsForSpeci?: Maybe<GetStationDetailsForSpeciResponse>;
};


export type GrowerServiceQueryListBaleDetailsArgs = {
  request: ListBaleDetailsRequestInput;
};


export type GrowerServiceQueryListCreditorHistoryArgs = {
  request: ListCreditorHistoryRequestInput;
};


export type GrowerServiceQueryListLotDetailsArgs = {
  request: ListLotDetailsRequestInput;
};


export type GrowerServiceQueryListOffersArgs = {
  request: GrowerListOffersRequestInput;
};


export type GrowerServiceQueryListReceivalHistoryArgs = {
  request: ListReceivalHistoryRequestInput;
};


export type GrowerServiceQueryListSoldWoolSummaryArgs = {
  request: ListSoldWoolSummaryRequestInput;
};


export type GrowerServiceQueryListSpecisArgs = {
  request: ListSpeciGrowerRequestInput;
};


export type GrowerServiceQueryListWoolContractsArgs = {
  request: ListWoolContractsRequestInput;
};


export type GrowerServiceQueryOfferArgs = {
  request: GetOfferRequestInput;
};


export type GrowerServiceQuerySpeciArgs = {
  request: GetSpeciRequestInput;
};


export type GrowerServiceQueryStationDetailsForSpeciArgs = {
  request: GetStationDetailsForSpeciRequestInput;
};

export enum ListBaleDetailsOrderByOptions {
  BaleNumber = 'BALE_NUMBER',
  LineNumber = 'LINE_NUMBER'
}

/** A request to list all wool lots */
export type ListBaleDetailsRequestInput = {
  baleNumber?: InputMaybe<Scalars['String']['input']>;
  currentPage: Scalars['Int']['input'];
  orderBy: ListBaleDetailsOrderByOptions;
  orderByAscending: Scalars['Boolean']['input'];
  pageSize: Scalars['Int']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['String']['input']>;
  stationRecordNumber: Scalars['String']['input'];
};

export type ListBaleDetailsResponse = {
  __typename?: 'ListBaleDetailsResponse';
  currentPage: Scalars['Int']['output'];
  results: Array<BaleDetail>;
  totalNetKGs?: Maybe<Scalars['Decimal']['output']>;
  totalPageCount: Scalars['Int']['output'];
  totalResultCount: Scalars['Int']['output'];
};

/** Request to get creditor history for stations */
export type ListCreditorHistoryRequestInput = {
  /** (Optional) The PaymentDate to start from */
  fromPaymentDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** (Optional) True if creditor history for all stations in station group should be returned */
  includeStationGroup?: Scalars['Boolean']['input'];
  /** The station record number. */
  stationRecordNumber: Scalars['String']['input'];
  /** (Optional) The PaymentDate to end at */
  toPaymentDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

/** List of creditor history details */
export type ListCreditorHistoryResponse = {
  __typename?: 'ListCreditorHistoryResponse';
  /** List of Creditor History details */
  results: Array<CreditorHistoryDetail>;
  /** Sum of GrossProceedsExGST */
  sumOfGrossProceedsExGST: Scalars['Decimal']['output'];
  /** Sum of NetProceedsGSTInclusive */
  sumOfNetProceedsGSTInclusive: Scalars['Decimal']['output'];
  /** Sum of TotalBalesInPayment */
  sumOfTotalBales: Scalars['Decimal']['output'];
  /** Sum of TotalNetKgInPayment */
  sumOfTotalNetKg: Scalars['Decimal']['output'];
};

/** Request to get lot details for a station */
export type ListLotDetailsRequestInput = {
  /** (Optional) The breed, used for filtering */
  breed?: InputMaybe<Breed>;
  /** (Optional) The PurchaseAccountName, used for filtering */
  purchaseAccountName?: InputMaybe<Scalars['String']['input']>;
  /** (Optional) The Result (soldStatus), used for filtering */
  result?: InputMaybe<WoolSoldStatus>;
  /** (Optional) The SaleAndSeason, used for filtering */
  saleAndSeason?: InputMaybe<Scalars['String']['input']>;
  /** (Optional) The season, used for filtering */
  season?: InputMaybe<Scalars['String']['input']>;
  /** The station record number. */
  stationRecordNumber: Scalars['String']['input'];
  /** (Optional) The stock, used for filtering */
  stock?: InputMaybe<StockAge>;
};

/** Response object */
export type ListLotDetailsResponse = {
  __typename?: 'ListLotDetailsResponse';
  /** Totals from lot details */
  lotDetailTotals: LotDetailTotals;
  /** Weighted averages from lot details */
  lotDetailWeightedAverages: LotDetailWeightedAverages;
  /** List of lot details entities */
  results: Array<LotDetail>;
};

export enum ListOffersOrderByOptions {
  Created = 'CREATED'
}

export type ListOffersResponse = {
  __typename?: 'ListOffersResponse';
  currentPage: Scalars['Int']['output'];
  results: Array<OfferDto>;
  totalPageCount: Scalars['Int']['output'];
  totalResultCount: Scalars['Int']['output'];
};

/** Request the receival history data for a station */
export type ListReceivalHistoryRequestInput = {
  /** (Optional) The DateReceived to start from */
  fromDateReceived?: InputMaybe<Scalars['LocalDate']['input']>;
  /** The station record number */
  stationRecordNumber: Scalars['String']['input'];
  /** (Optional) The DateReceived to end at */
  toDateReceived?: InputMaybe<Scalars['LocalDate']['input']>;
};

/** Receival history details */
export type ListReceivalHistoryResponse = {
  __typename?: 'ListReceivalHistoryResponse';
  /** A list of receival histories */
  results: Array<ReceivalHistoryDetail>;
  /** A sum of all of TotalBalesReceived values */
  sumOfTotalBalesReceived: Scalars['Decimal']['output'];
};

/** Request to get sold wool summary for station */
export type ListSoldWoolSummaryRequestInput = {
  /** The first season to return, returns this season plus the five previous seasons. */
  firstSeason: Scalars['Int']['input'];
  /** The station record number. */
  stationRecordNumber: Scalars['String']['input'];
};

/** List of sold wool summaries */
export type ListSoldWoolSummaryResponse = {
  __typename?: 'ListSoldWoolSummaryResponse';
  /** List of sold wool summaries */
  results: Array<SoldWoolSummary>;
};

export type ListSpeciGrowerRequestInput = {
  stationRecordNumber: Scalars['String']['input'];
};

/** List of speci summary records */
export type ListSpeciResponse = {
  __typename?: 'ListSpeciResponse';
  /** List of speci summary records */
  results: Array<SpeciSummary>;
};

/** Request to get wool contracts for stations */
export type ListWoolContractsRequestInput = {
  /** (Optional) The season, used for filtering (targeting WoolExpectedDate/ContractDeliveryDate/pa_erdate). Eg: 2024 */
  season?: InputMaybe<Scalars['Int']['input']>;
  /** The station record number. */
  stationRecordNumber: Scalars['String']['input'];
};

/** List of wool contracts */
export type ListWoolContractsResponse = {
  __typename?: 'ListWoolContractsResponse';
  /** List of wool contracts */
  results: Array<WoolContract>;
  /** Sum of BalesContracted */
  sumOfBalesContracted: Scalars['Decimal']['output'];
};

/** A combination of OfferStatus and LoomWoolLotOfferStatus to represent the status of a LoomWoolLot"/> */
export enum LoomWoolLotOfferStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  UnderOffer = 'UNDER_OFFER'
}

export type LotDetail = {
  __typename?: 'LotDetail';
  /** Bales (total) (Talman: lh_tbales) */
  bales?: Maybe<Scalars['Decimal']['output']>;
  /** The clean weight (calculated from the net weight and the yield) */
  cleanKgs?: Maybe<Scalars['Decimal']['output']>;
  /** Lot no (broker) (Talman: lh_code) */
  code?: Maybe<Scalars['String']['output']>;
  /** The co-efficient of the variation in micron (Talman: ct_lscvm) */
  coreTestCoefficientOfVariationLaserscan?: Maybe<Scalars['Decimal']['output']>;
  /** Colour (Y-Z core test) (Talman: ct_colyz) */
  coreTestColourYZ?: Maybe<Scalars['Decimal']['output']>;
  /** Micron (Talman: ct_mic) */
  coreTestMicron?: Maybe<Scalars['Decimal']['output']>;
  /** Micron (Airflow) (Talman: ct_afmic) */
  coreTestMicronAirflow?: Maybe<Scalars['Decimal']['output']>;
  /** Micron (Laserscan) (Talman: ct_lsmic) */
  coreTestMicronLaserscan?: Maybe<Scalars['Decimal']['output']>;
  /** Micron (OFDA) (Talman: ct_ofmic) */
  coreTestMicronOfda?: Maybe<Scalars['Decimal']['output']>;
  /** Point of break base (Talman: ct_pobb) */
  coreTestPointOfBreakBase?: Maybe<Scalars['Decimal']['output']>;
  /** Point of break mid (Talman: ct_pobm) */
  coreTestPointOfBreakMid?: Maybe<Scalars['Decimal']['output']>;
  /** Point of break tip (Talman: ct_pobt) */
  coreTestPointOfBreakTip?: Maybe<Scalars['Decimal']['output']>;
  /** Average Staple Strength (Talman: ct_avstr) */
  coreTestStapleAverageStrength?: Maybe<Scalars['Decimal']['output']>;
  /** Staple length (greasy core test) (Talman: ct_slen) */
  coreTestStapleLengthGreasy?: Maybe<Scalars['Decimal']['output']>;
  /** Staple strength (core test) (Talman: ct_str) */
  coreTestStapleStrength?: Maybe<Scalars['Decimal']['output']>;
  /** VMB (core test) (Talman: ct_vmb) */
  coreTestVegetableMatterBase?: Maybe<Scalars['Decimal']['output']>;
  /** Yield 1 (Talman: ct_yld1) */
  coreTestYield?: Maybe<Scalars['Decimal']['output']>;
  /** Wool Lot's Main Bale Header PurchaseDescription (Talman: bh_samploc) */
  description?: Maybe<Scalars['String']['output']>;
  /** The Wool Lot's Gross Proceeds (calculated) */
  grossProceeds?: Maybe<Scalars['Decimal']['output']>;
  /** Line Number (Talman: lh_text3) */
  lineNumber?: Maybe<Scalars['String']['output']>;
  /** Commission payment date (Talman: lh_comdate) */
  lottedDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Net Kilograms (Talman: lh_rnetkg) */
  netKgs?: Maybe<Scalars['Decimal']['output']>;
  /** Payment Date (Talman: lh_prpdate) */
  paymentDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The Wool Lot's Clean Price for the current basis (calculated) */
  priceClean?: Maybe<Scalars['Decimal']['output']>;
  /** The Wool Lot's Greasy Price for the current basis (calculated) */
  priceGreasy?: Maybe<Scalars['Decimal']['output']>;
  /** The name of the Wool Lot's Purchase Account (Talman: pa_name) */
  purchaseAccountName?: Maybe<Scalars['String']['output']>;
  /** Quality scheme 2 (Talman: lh_qsch2) */
  qualityScheme2?: Maybe<Scalars['String']['output']>;
  /** Record type (Talman: lh_rtype) */
  recordType?: Maybe<Scalars['String']['output']>;
  /** Internal Comment (Talman: lh_intcomm) */
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** The Wool Lot's Sold Status Result */
  result?: Maybe<WoolSoldStatus>;
  /** Sale number (Talman: lh_sale) */
  sale?: Maybe<Scalars['String']['output']>;
  /** Sale Account Code (Talman: lh_scode) */
  saleAccount?: Maybe<Scalars['String']['output']>;
  /** A combination of SaleNumber (Talman: lh_sale) and Season (Talman: lh_season) */
  saleAndSeason?: Maybe<Scalars['String']['output']>;
  /** The location of the sample Wool (Talman: bh_samploc) */
  sample?: Maybe<Scalars['String']['output']>;
  /** Season (Talman: lh_season) */
  season?: Maybe<Scalars['String']['output']>;
  /** The current type (Talman: lh_typec) */
  type?: Maybe<Scalars['String']['output']>;
  /** Reweigh Input Time (Talman: ct_rwdate) */
  weighDate?: Maybe<Scalars['DateTime']['output']>;
};

/** Represents the totals of a list of LotDetail */
export type LotDetailTotals = {
  __typename?: 'LotDetailTotals';
  /** A total of Bale values */
  bales?: Maybe<Scalars['Decimal']['output']>;
  /** A total of GrossProceeds */
  grossProceeds?: Maybe<Scalars['Decimal']['output']>;
  /** A total of NetKgs */
  netKgs?: Maybe<Scalars['Decimal']['output']>;
};

/** Represents the weighted averages of a list of LotDetail */
export type LotDetailWeightedAverages = {
  __typename?: 'LotDetailWeightedAverages';
  coreTestCoefficientOfVariationLaserscan?: Maybe<Scalars['Decimal']['output']>;
  coreTestColourYZ?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicron?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicronAirflow?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicronLaserscan?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicronOfda?: Maybe<Scalars['Decimal']['output']>;
  coreTestPointOfBreakBase?: Maybe<Scalars['Decimal']['output']>;
  coreTestPointOfBreakMid?: Maybe<Scalars['Decimal']['output']>;
  coreTestPointOfBreakTip?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleAverageStrength?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleLengthGreasy?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleStrength?: Maybe<Scalars['Decimal']['output']>;
  coreTestVegetableMatterBase?: Maybe<Scalars['Decimal']['output']>;
  coreTestYield?: Maybe<Scalars['Decimal']['output']>;
  priceClean?: Maybe<Scalars['Decimal']['output']>;
  priceGreasy?: Maybe<Scalars['Decimal']['output']>;
};

/** A standardised response to a mutation */
export type MutationResponse = {
  __typename?: 'MutationResponse';
  /** An associated error message if unsuccessful */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** If the mutation was a success (or not) */
  success: Scalars['Boolean']['output'];
};

/** A combination of LoomStation and Offer */
export type OfferDto = {
  __typename?: 'OfferDto';
  completedDateTime?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  expiryDateTime: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The WoolLotOffers for this Offer */
  lines: Array<WoolLotOfferDto>;
  offerFrom: Scalars['String']['output'];
  paymentDate: Scalars['LocalDate']['output'];
  personalisedComment?: Maybe<Scalars['String']['output']>;
  respondedBy?: Maybe<Scalars['String']['output']>;
  stationBrand?: Maybe<Scalars['String']['output']>;
  stationRecordNumber?: Maybe<Scalars['String']['output']>;
  status: OfferStatus;
  submittedOnBehalfOfGrower?: Maybe<Scalars['Boolean']['output']>;
};

export enum OfferStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  UnderOffer = 'UNDER_OFFER'
}

export type ReceivalHistoryDetail = {
  __typename?: 'ReceivalHistoryDetail';
  /** nzwprxh.rx_rdate */
  dateReceived?: Maybe<Scalars['LocalDate']['output']>;
  /** nzwprxh.rx_pcode */
  purchaseAccountCode?: Maybe<Scalars['String']['output']>;
  /** nzwprxh.rx_stcent */
  storageCentreCode?: Maybe<Scalars['String']['output']>;
  /** nzwprxh.rx_tbales */
  totalBalesReceived?: Maybe<Scalars['Decimal']['output']>;
};

/** Upserts a Speci */
export type SetSpeciRequestInput = {
  /** The Speci to upsert */
  speci: SpeciDtoInput;
  /** The station record number to associate the Speci with */
  stationRecordNumber: Scalars['String']['input'];
};

export type SoldWoolSummary = {
  __typename?: 'SoldWoolSummary';
  averageBaleWeight?: Maybe<Scalars['Int']['output']>;
  averageGrossPricePerKgExGST?: Maybe<Scalars['Decimal']['output']>;
  averageNetPricePerKgIncGST?: Maybe<Scalars['Decimal']['output']>;
  season?: Maybe<Scalars['String']['output']>;
  totalBales?: Maybe<Scalars['Int']['output']>;
  totalGrossProceedsExGST?: Maybe<Scalars['Decimal']['output']>;
  totalKgs?: Maybe<Scalars['Int']['output']>;
  totalNetProceedsIncGST?: Maybe<Scalars['Decimal']['output']>;
};

export enum SpeciConsignmentStatus {
  ConsignmentComplete = 'CONSIGNMENT_COMPLETE',
  ConsignmentNotCompleteHoldForBalance = 'CONSIGNMENT_NOT_COMPLETE_HOLD_FOR_BALANCE',
  ShearingNotCompleteSellQualifiedWool = 'SHEARING_NOT_COMPLETE_SELL_QUALIFIED_WOOL'
}

/** Contract detail for a speci */
export type SpeciContractDetail = {
  __typename?: 'SpeciContractDetail';
  /** The name of the associated LoomPurchaseAccount (Talman: pa_name) */
  contractName?: Maybe<Scalars['String']['output']>;
  /** The RecordNumber of the associated LoomPurchaseAccount (Talman: pa_code) */
  recordNumber: Scalars['String']['output'];
};

export type SpeciDto = {
  __typename?: 'SpeciDto';
  /** Breeds of sheep included in the Speci */
  breeds: Array<Scalars['String']['output']>;
  /** Classer working on the Speci (which may be different than currently logged in user) */
  classer?: Maybe<Scalars['String']['output']>;
  /** Comments from the classer */
  classerComment?: Maybe<Scalars['String']['output']>;
  /** The consignment status of the speci */
  consignmentStatus?: Maybe<SpeciConsignmentStatus>;
  /** The Id of the speci entity */
  id: Scalars['UUID']['output'];
  /** A list of the related SpeciLineDto. */
  lines: Array<SpeciLineDto>;
  /** The date and time the speci was sent to the wool store by NZM user */
  sentToWoolStoreAt?: Maybe<Scalars['DateTime']['output']>;
  /** The person (typically NZM user) that sent the speci to the wool store */
  sentToWoolStoreBy?: Maybe<Scalars['String']['output']>;
  /** The email address of the area manager of the station to which this speci is linked */
  stationAreaManagerEmail?: Maybe<Scalars['String']['output']>;
  /** The full name of the area manager of the station to which this speci is linked */
  stationAreaManagerFullName?: Maybe<Scalars['String']['output']>;
  /** The Type of Speci (Grower vs Hub) */
  type?: Maybe<SpeciType>;
  /** Wool store associated with the speci */
  woolStore?: Maybe<Scalars['String']['output']>;
};

export type SpeciDtoInput = {
  /** Breeds of sheep included in the Speci */
  breeds: Array<Scalars['String']['input']>;
  /** Classer working on the Speci (which may be different than currently logged in user) */
  classer?: InputMaybe<Scalars['String']['input']>;
  /** Comments from the classer */
  classerComment?: InputMaybe<Scalars['String']['input']>;
  /** The consignment status of the speci */
  consignmentStatus?: InputMaybe<SpeciConsignmentStatus>;
  /** The Id of the speci entity */
  id: Scalars['UUID']['input'];
  /** A list of the related SpeciLineDto. */
  lines: Array<SpeciLineDtoInput>;
  /** The date and time the speci was sent to the wool store by NZM user */
  sentToWoolStoreAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The person (typically NZM user) that sent the speci to the wool store */
  sentToWoolStoreBy?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the area manager of the station to which this speci is linked */
  stationAreaManagerEmail?: InputMaybe<Scalars['String']['input']>;
  /** The full name of the area manager of the station to which this speci is linked */
  stationAreaManagerFullName?: InputMaybe<Scalars['String']['input']>;
  /** The Type of Speci (Grower vs Hub) */
  type?: InputMaybe<SpeciType>;
  /** Wool store associated with the speci */
  woolStore?: InputMaybe<Scalars['String']['input']>;
};

export type SpeciLineDto = {
  __typename?: 'SpeciLineDto';
  /** The Bale Numbers associated with the Line */
  baleNumbers: Array<Scalars['Int']['output']>;
  /** The Description of the Line */
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The Instructions or Contract name that the Line is intended for */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The Line Number, an optional identifier for the Line */
  number?: Maybe<Scalars['String']['output']>;
  /** The original instructions from the SpeciLine created by the external user (for Hub Speci versions) */
  originalInstructions?: Maybe<Scalars['String']['output']>;
  /** The Traditional Description of the Line */
  traditionalDescription?: Maybe<Scalars['String']['output']>;
};

export type SpeciLineDtoInput = {
  /** The Bale Numbers associated with the Line */
  baleNumbers: Array<Scalars['Int']['input']>;
  /** The Description of the Line */
  description: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  /** The Instructions or Contract name that the Line is intended for */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** The Line Number, an optional identifier for the Line */
  number?: InputMaybe<Scalars['String']['input']>;
  /** The original instructions from the SpeciLine created by the external user (for Hub Speci versions) */
  originalInstructions?: InputMaybe<Scalars['String']['input']>;
  /** The Traditional Description of the Line */
  traditionalDescription?: InputMaybe<Scalars['String']['input']>;
};

export enum SpeciStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type SpeciSummary = {
  __typename?: 'SpeciSummary';
  author: Scalars['String']['output'];
  breeds: Array<Scalars['String']['output']>;
  completed?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  originalSpeciCompleted?: Maybe<Scalars['DateTime']['output']>;
  originalSpeciCreated?: Maybe<Scalars['DateTime']['output']>;
  originalSpeciId?: Maybe<Scalars['UUID']['output']>;
  originalSpeciSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  originalSpeciSubmittedBy?: Maybe<Scalars['String']['output']>;
  sentToWoolStoreAt?: Maybe<Scalars['DateTime']['output']>;
  sentToWoolStoreBy?: Maybe<Scalars['String']['output']>;
  status: SpeciStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  totalBales: Scalars['Int']['output'];
};

export enum SpeciType {
  Grower = 'GROWER',
  Hub = 'HUB'
}

export enum StationAuthRole {
  FullAccess = 'FULL_ACCESS',
  NonFinancial = 'NON_FINANCIAL'
}

export enum StockAge {
  All = 'ALL',
  Ewes = 'EWES',
  Hoggets = 'HOGGETS',
  Lambs = 'LAMBS',
  Unclassified = 'UNCLASSIFIED',
  Wethers = 'WETHERS'
}

export type SubmitOfferRequestInput = {
  offerId: Scalars['UUID']['input'];
  woolLotOfferDecisions: Array<WoolLotOfferDecisionInput>;
};

export type SubmitSpeciRequestInput = {
  speciId: Scalars['UUID']['input'];
};

/**
 * A representation of LoomPurchaseAccount for Wool Contracts functionality,
 * some fields are transformed:
 *  - MicronMin is minimum acceptable micron for the contract
 *  - MicronMax is maximum acceptable micron for the contract
 *  - TargetMinimumYield is minimum acceptable yield for the contract
 *  - GreasyLengthMin is minimum acceptable greasy length for the contract
 *  - GreasyLengthMax is maximum acceptable greasy length for the contract
 * See ListWoolContractsHandler for implementation of field transformations.
 */
export type WoolContract = {
  __typename?: 'WoolContract';
  /** nzwppacc.pa_pprice */
  averagePriceCLN?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_qty */
  balesContracted?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_colour */
  colourDescription?: Maybe<Scalars['String']['output']>;
  /** nzwppacc.pa_erdate */
  contractDeliveryDate?: Maybe<Scalars['LocalDate']['output']>;
  /** If the Grower has signed the contract */
  contractIsSigned: Scalars['Boolean']['output'];
  /** nzwppacc.pa_name */
  contractName?: Maybe<Scalars['String']['output']>;
  contractedLots: Array<ContractedLot>;
  /** Calculated by the handler */
  greasyLengthMax?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated by the handler */
  greasyLengthMin?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated by the handler */
  micronMax?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated by the handler */
  micronMin?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_code */
  purchaseAccountRecordNumber: Scalars['String']['output'];
  /** nzwppacc.pa_style */
  styleDescription?: Maybe<Scalars['String']['output']>;
  /** nzwppacc.pa_gsl */
  targetGreasyLength?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_mic */
  targetMicron?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated by the handler */
  targetMinimumYield?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_ss */
  targetSampleStrength?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_vmb */
  targetVegetableMatter?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated sum of TotalBales of all ContractedLots with a Result of Accepted */
  totalBalesAccepted?: Maybe<Scalars['Decimal']['output']>;
};

export type WoolLotOfferDecisionInput = {
  accepted: Scalars['Boolean']['input'];
  woolLotOfferId: Scalars['UUID']['input'];
};

/** A client-side representation of WoolLotOffer */
export type WoolLotOfferDto = {
  __typename?: 'WoolLotOfferDto';
  /** The brand partner for which the price offer is destined, displayed on the offer alongside the price */
  brandPartner?: Maybe<Scalars['String']['output']>;
  /** The clean market price for the WoolLot - units of cents per kg */
  cleanMarketPrice?: Maybe<Scalars['Int']['output']>;
  /** The clean price offered for the WoolLot - units of cents per kg */
  cleanOfferPrice?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  coreTestColourYZ?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicron?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleLengthGreasy?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleStrength?: Maybe<Scalars['Decimal']['output']>;
  coreTestVegetableMatterBase?: Maybe<Scalars['Decimal']['output']>;
  coreTestYield?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The setting controlling if value add should be displayed on the offer
   * Normally, NZM staff choose not to display value add on the offer if it is a very small benefit to the grower
   */
  displayValueAdd?: Maybe<Scalars['Boolean']['output']>;
  /** The greasy market price for the WoolLot - units of cents per kg */
  greasyMarketPrice?: Maybe<Scalars['Int']['output']>;
  /** The greasy price offered for the WoolLot - units of cents per kg */
  greasyOfferPrice?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  interlotWarning: Scalars['Boolean']['output'];
  internalReferenceCode: Scalars['String']['output'];
  lineNumber?: Maybe<Scalars['String']['output']>;
  mainBaleHeaderPurchaseDescription?: Maybe<Scalars['String']['output']>;
  netKg?: Maybe<Scalars['Decimal']['output']>;
  purchaseAccountName?: Maybe<Scalars['String']['output']>;
  qualityScheme2?: Maybe<Scalars['String']['output']>;
  qualitySchemeWarning: Scalars['Boolean']['output'];
  saleNumber?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['String']['output']>;
  stationBrand?: Maybe<Scalars['String']['output']>;
  stationRecordNumber?: Maybe<Scalars['String']['output']>;
  /** The status of the offers made on the lot */
  status?: Maybe<LoomWoolLotOfferStatus>;
  totalBales?: Maybe<Scalars['Decimal']['output']>;
  typeCurrent?: Maybe<Scalars['String']['output']>;
  /**
   * The value add of the price offer - units of dollars for entire lot
   * This represents benefit to the grower if they accept the offer
   * This is calculated client-side (in the Hub front-end)
   */
  valueAdd?: Maybe<Scalars['Decimal']['output']>;
};

export enum WoolSoldStatus {
  SoldOrBin = 'SOLD_OR_BIN',
  Unsold = 'UNSOLD'
}
